<template>
  <div class="page-wrap">
    <div class="header-filter">
      <div class="header-text">投放信息记录</div>
      <div class="select-wrap">
        <el-date-picker
          v-model="week"
          type="week"
          :format="'yyyy第WW周  ( ' + weekArr[0] + ' - ' + weekArr[1] + ' )'"
          value-format="yyyy-MM-dd"
          placeholder="选择周"
          style="width: 320px; margin-right: 24px"
          :clearable="false"
          :picker-options="{ firstDayOfWeek: 1 }"
        >
        </el-date-picker>
        <el-select
          class="multiple-select"
          v-model="filterData.market"
          filterable
          multiple
          collapse-tags
          placeholder="全部市场"
          @change="searchData(true)"
        >
          <el-option label="谷歌" value="谷歌"> </el-option>
          <el-option label="IOS" value="IOS"> </el-option>
          <el-option label="华为海外" value="华为海外"> </el-option>
          <el-option label="亚马逊" value="亚马逊"> </el-option>
          <el-option label="传音海外" value="传音海外"> </el-option>
        </el-select>
        <el-select
          class="multiple-select"
          v-model="filterData.productId"
          placeholder="全部产品"
          multiple
          filterable
          collapse-tags
          @change="searchData(true)"
        >
          <el-option v-for="item in productList" :key="item.id" :label="item.appName" :value="item.id"> </el-option>
        </el-select>
        <el-select
          class="multiple-select"
          v-model="filterData.principalUser"
          placeholder="全部投放负责人"
          multiple
          collapse-tags
          @change="searchData(true)"
        >
          <el-option v-for="item in principalNameList" :key="item.id" :label="item.principalName" :value="item.principalName"> </el-option>
        </el-select>
        <el-select
          class="multiple-select"
          v-model="filterData.productStatus"
          placeholder="全部产品状态"
          multiple
          collapse-tags
          @change="searchData(true)"
        >
          <el-option label="稳定投放" value="稳定投放"> </el-option>
          <el-option label="已暂停" value="已暂停"> </el-option>
          <el-option label="测试中" value="测试中"> </el-option>
          <el-option label="上线待测试" value="上线待测试"> </el-option>
        </el-select>
        <el-select
          class="multiple-select"
          v-model="filterData.productPrincipalUser"
          placeholder="全部产品负责人"
          multiple
          collapse-tags
          @change="searchData(true)"
        >
          <el-option v-for="item in principalUserList" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
        <el-select
          class="multiple-select"
          v-model="filterData.productGroupName"
          placeholder="全部项目组"
          multiple
          collapse-tags
          @change="searchData(true)"
        >
          <el-option v-for="item in productGroupNameList" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
        <el-select
          class="multiple-select"
          v-model="filterData.groupName"
          placeholder="全部产品分组"
          multiple
          collapse-tags
          @change="searchData(true)"
        >
          <el-option v-for="item in groupNameList" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
        <el-dropdown @command="handleCommand">
          <el-button type="primary"> 导入Excel<i class="el-icon-arrow-down el-icon--right"></i> </el-button>

          <el-dropdown-menu slot="dropdown">
            <el-upload
              class="upload-demo"
              action=""
              :auto-upload="false"
              :multiple="false"
              :show-file-list="false"
              :on-change="uploadExcel"
              :file-list="fileList"
            >
              <el-dropdown-item command="1">单个sheet录入</el-dropdown-item>
              <el-dropdown-item command="2">全部sheet录入</el-dropdown-item>
            </el-upload>
          </el-dropdown-menu>
        </el-dropdown>

        <el-button type="primary" style="margin-left: 12px" :loading="downloadLoading" @click="downloadReport">导出</el-button>
        <el-button type="primary" style="margin-left: 12px" @click="addPro" :disabled="readOnly">新增产品</el-button>
      </div>
    </div>
    <div class="table-wrap">
      <i class="el-icon-loading loading-icon" v-show="loading"></i>
      <el-table
        ref="table"
        :row-class-name="rowClassName"
        :cell-class-name="cellClassName"
        :data="tableData"
        style="width: 100%"
        height="100%"
        row-key="id"
        border
        :tree-props="{ children: 'children' }"
        v-loading="loadingTable"
        @header-dragend="headerDragend"
      >
        >
        <el-table-column
          v-for="item of columns"
          :key="item.value"
          :prop="item.value"
          :width="item.width || '200px'"
          :label="item.label"
          :fixed="item.fixed || null"
          :sortable="item.value === 'ranking'"
        >
          <template slot="header" v-if="item.value === 'chnl'">
            <span>渠道/主要渠道</span>
            <el-button type="text" style="margin-left: 8px" @click="customChnl">自定义</el-button>
          </template>
          <template slot-scope="scope">
            <div v-if="item.value === 'ranking'">
              <div class="rank-wrap" v-if="rankSet[scope.row.id]">
                <el-input-number
                  v-model="rankSet[scope.row.id].ranking"
                  placeholder="请输入"
                  :controls="false"
                  @blur="saveRank(scope.row)"
                ></el-input-number>
              </div>
              <div v-else-if="scope.row.isChild === 0" style="display: flex; height: 20px; align-items: center">
                <span>{{ scope.row[item.value] }}</span>
                <i
                  style="margin-left: auto"
                  @click="editRank(scope.row)"
                  v-if="!editDataSet[scope.row.id]"
                  class="edit-ranking el-icon-edit"
                ></i>
              </div>
              <div v-else>-</div>
            </div>

            <div v-else-if="item.value === 'type'">
              <el-select
                v-if="editDataSet[scope.row.id] && scope.row.isChild === 0"
                class="select-item"
                v-model="editDataSet[scope.row.id].type"
                placeholder="请选择"
              >
                <el-option label="投放测试" value="投放测试"></el-option>
                <el-option label="增加量级" value="增加量级"></el-option>
                <el-option label="减少量级" value="减少量级"></el-option>
                <el-option label="维持投放" value="维持投放"></el-option>
              </el-select>
              <div v-else>{{ scope.row.type || "--" }}</div>
            </div>

            <!-- 编辑列 -->
            <div v-else-if="item.value === 'appName'">
              <el-select
                v-if="editDataSet[scope.row.id] && scope.row.isChild === 0"
                class="select-item"
                v-model="editDataSet[scope.row.id].productId"
                placeholder="请选择"
              >
                <el-option v-for="item in productList" :key="item.id" :label="item.appName" :value="item.id"> </el-option>
              </el-select>
              <div v-else-if="scope.row.isChild === 0" class="show-text">
                <span :class="[scope.row.status === 4 ? 'red-text' : '']">{{ scope.row[item.value] || "-" }}</span>
                <svg-icon @click="showDetailModal(scope.row)" iconClass="detail" className="menu-icon"></svg-icon>
              </div>
              <div v-else>-</div>
            </div>
            <div v-else-if="item.value === 'chnl'">
              <channel-select
                width="180px"
                v-if="editDataSet[scope.row.id] && scope.row.isChild === 0"
                :option="channelList"
                v-model="editDataSet[scope.row.id][item.value]"
              ></channel-select>
              <div v-else class="show-text">
                <span v-for="(i, index) of scope.row[item.value]" :class="['channel-item', i.primary ? 'main' : '']" :key="i.channel">{{
                  scope.row[item.value].length - 1 === index ? i.channel : i.channel + "、"
                }}</span>
              </div>
            </div>

            <div v-else-if="item.value === 'market'">
              <el-select
                v-if="editDataSet[scope.row.id] && scope.row.isChild === 0"
                class="select-item"
                v-model="editDataSet[scope.row.id][item.value]"
                placeholder="请选择"
              >
                <el-option label="谷歌" value="谷歌"> </el-option>
                <el-option label="IOS" value="IOS"> </el-option>
                <el-option label="华为海外" value="华为海外"> </el-option>
                <el-option label="亚马逊" value="亚马逊"> </el-option>
                <el-option label="传音海外" value="传音海外"> </el-option>
              </el-select>
              <div v-else-if="scope.row.isChild === 0" class="show-text">
                <span>{{ scope.row[item.value] }}</span>
              </div>
              <div v-else>-</div>
            </div>

            <div v-else-if="item.value === 'productGrade'">
              <el-select
                v-if="editDataSet[scope.row.id] && scope.row.isChild === 0"
                class="select-item"
                v-model="editDataSet[scope.row.id][item.value]"
                placeholder="请选择"
              >
                <el-option label="A1" value="A1"> </el-option>
                <el-option label="A2" value="A2"> </el-option>
                <el-option label="B1" value="B1"> </el-option>
                <el-option label="B2" value="B2"> </el-option>
                <el-option label="空" value="空"> </el-option>
              </el-select>
              <div v-else-if="scope.row.isChild === 0" class="show-text">
                <span>{{ scope.row[item.value] }}</span>
              </div>
              <div v-else>-</div>
            </div>

            <div v-else-if="item.value === 'productStatus'">
              <el-select
                v-if="editDataSet[scope.row.id]"
                class="select-item"
                v-model="editDataSet[scope.row.id][item.value]"
                placeholder="请选择"
              >
                <el-option label="稳定投放" value="稳定投放"> </el-option>
                <el-option label="已暂停" value="已暂停"> </el-option>
                <el-option label="测试中" value="测试中"> </el-option>
                <el-option label="上线待测试" value="上线待测试"> </el-option>
              </el-select>
              <div v-else class="show-text">
                <span>{{ scope.row[item.value] }}</span>
              </div>
            </div>

            <div v-else-if="item.value === 'principalName'">
              <el-select
                v-if="editDataSet[scope.row.id]"
                class="select-item"
                v-model="editDataSet[scope.row.id].principalName"
                placeholder="请选择"
                filterable
                allow-create
                multiple
                :multiple-limit="scope.row.isChild"
              >
                <el-option v-for="item in principalNameList" :key="item.id" :label="item.principalName" :value="item.principalName">
                </el-option>
              </el-select>
              <div v-else class="show-text">
                <span>{{ scope.row[item.value].join() }}</span>
              </div>
            </div>

            <div
              class="chnl-wrap"
              v-else-if="['productDirection', 'recoveryAnalysis', 'chnlRegion', 'adjustmentRemarks'].includes(item.value)"
            >
              <div class="area-wrap">
                <div>
                  <i
                    v-if="editDataSet[scope.row.id]"
                    @click="editRichText(item, scope.row[item.value], scope.row.id)"
                    class="edit-ranking el-icon-edit"
                  ></i>

                  <div class="html-textarea" v-if="editDataSet[scope.row.id]" v-html="editDataSet[scope.row.id][item.value]"></div>
                  <div class="html-textarea" v-else v-html="scope.row[item.value]"></div>
                </div>
              </div>

              <el-popover placement="right-start" width="300" trigger="hover">
                <div class="html-textarea" v-html="scope.row[item.value + 'History']"></div>
                <svg-icon v-show="scope.row[item.value + 'History']" slot="reference" iconClass="history" className="menu-icon"></svg-icon>
              </el-popover>
            </div>

            <div v-else-if="item.value === 'marketLocal' || item.value === 'gameLocal'">
              <el-input
                v-if="editDataSet[scope.row.id]"
                v-model="editDataSet[scope.row.id][item.value]"
                class="input-area"
                type="textarea"
                :rows="3"
                placeholder="请输入"
                resize="none"
              >
              </el-input>

              <div v-else class="show-text">
                <span>{{ scope.row[item.value] }}</span>
              </div>
            </div>

            <div v-else-if="item.value === 'resourceNum'">
              <el-input-number
                style="width: 100px"
                controls-position="right"
                v-if="editDataSet[scope.row.id]"
                v-model="editDataSet[scope.row.id][item.value]"
                placeholder="请输入"
                :min="1"
                :max="1000"
              ></el-input-number>
              <div v-else class="show-text">
                <span>{{ scope.row[item.value] }}</span>
              </div>
            </div>

            <!-- 操作 -->
            <div v-else-if="item.value === 'doSth'">
              <div v-if="editDataSet[scope.row.id]" class="edit-btns">
                <el-button type="text" size="small" @click="saveData(scope.row)">保存</el-button>
                <el-button type="text" size="small" @click="cancel(scope.row)">取消</el-button>
              </div>
              <el-button v-else type="text" size="small" @click="editLine(scope.row)" :disabled="readOnly">编辑</el-button>
              <el-button type="text" size="small" @click="deleteData(scope.row)" :disabled="readOnly">删除</el-button>
            </div>

            <!-- 只读数据 -->
            <span v-else>{{ scope.row[item.value] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <self-pagination
      class="footer-page"
      :total="pageData.total"
      :pageSize="pageData.size"
      :currentPage="pageData.page"
      ref="tabelPagination"
      @getCurrentPage="changePage"
      @handleSizeChange="changePageSize"
      :hideSiglePage="false"
    ></self-pagination>

    <!-- 详情弹框 -->
    <detail-modal :readOnly="readOnly" @refresh="searchData" ref="detailModalRef"></detail-modal>

    <!-- 新增弹框 -->
    <add-modal @refresh="searchData" :productList="productList" ref="addModalRef"></add-modal>

    <!-- 渠道弹框 -->
    <chnl-modal @modalClosed="searchChnlList" ref="chnlModalRef"></chnl-modal>
    <!-- 表格数据错误弹窗 -->
    <el-dialog title="警告" :visible.sync="errorDialogVisible" width="30%">
      <div class="error-title">表格部分数据由于存在错误而导入失败（如下）:</div>
      <div class="error" v-for="(item, index) in errorList" :key="index">
        <div v-if="item.list.length > 0">
          <div class="error-content">{{ item.errorMsg }}：</div>
          <div class="error-value" v-for="(child, idx) in item.list" :key="idx">
            <div class="number" v-if="item.key === 6">{{ child.orderNum }}</div>
            <div v-else>
              sheet页：<span class="number">{{ child.sheetNum }}</span> 序号：<span class="number">{{ child.orderNum }}</span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="errorDialogVisible = false">我知道了</el-button>
      </span>
    </el-dialog>
    <!-- 富文本编辑弹窗 -->
    <edit-rich ref="editRich" @handleConfirm="handleConfirmEditRich"></edit-rich>
  </div>
</template>

<script>
import DetailModal from "../common/detailModal.vue";
import ChnlModal from "../common/chnlModal.vue";
import AddModal from "./addModal.vue";
import EditRich from "./editRich.vue";
import moment from "moment";
import ChannelSelect from "./channelSelect.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import { downLoadWrokSheet } from "@/utils/commonTools.js";
import axios from "axios";
import {
  getPros,
  getPrincipalName,
  getTotalReportParams,
  getProductLog,
  modProductLog,
  delProductLog,
  changeRanking,
  getChnl,
  getColumn,
  addColumn,
  // uploadProductLogData,
} from "@/api/popuManage.js";
export default {
  name: "InfoRecord",
  components: {
    DetailModal,
    AddModal,
    ChannelSelect,
    SvgIcon,
    ChnlModal,
    EditRich,
  },
  data() {
    return {
      week: null,
      filterData: {
        market: [],
        productId: [],
        principalUser: [],
        productStatus: [],
        productPrincipalUser: [],
        productGroupName: [],
        groupName: [],
      },
      pageData: {
        total: 0,
        size: 100,
        page: 1,
      },
      loading: false,
      loadingTable: false,
      productList: [],
      principalNameList: [],
      groupNameList: [],
      principalUserList: [],
      productGroupNameList: [],
      tableData: [],
      editDataSet: {},
      rankSet: {},
      columns: [
        { label: "", value: "fold", width: "40px", fixed: "left" },
        { label: "序号", value: "ranking", width: "80px", fixed: "left" },
        { label: "市场", value: "market", width: "140px", fixed: "left" },
        {
          label: "产品分级",
          value: "productGrade",
          width: "100px",
          fixed: "left",
        },
        { label: "产品名称", value: "appName", fixed: "left" },
        {
          label: "投放负责人",
          value: "principalName",
          width: "172px",
          fixed: "left",
        },
        { label: "市场本地化", value: "marketLocal", width: "150px" },
        { label: "游戏本地化", value: "gameLocal", width: "150px" },
        { label: "产品状态", value: "productStatus", width: "140px" },
        { label: "产品方向", value: "productDirection", width: "300px" },
        { label: "回收分析", value: "recoveryAnalysis", width: "300px" },
        { label: "渠道/主要渠道", value: "chnl" },
        { label: "渠道/地区确认", value: "chnlRegion", width: "300px" },
        { label: "调整备注", value: "adjustmentRemarks", width: "300px" },
        { label: "素材迭代组数", value: "resourceNum", width: "110px" },
        { label: "类型", value: "type", width: "130px" },
        { label: "操作", value: "doSth", width: "160px", fixed: "right" },
      ],
      channelList: [],
      fileList: [], //上传的文件列表
      reqType: "",
      errorDialogVisible: false,
      errorList: [],
      downloadLoading: false,
    };
  },
  created() {
    if ("EventSource" in window) {
      let that = this;
      var source = new EventSource(`${process.env.VUE_APP_BASE_URL}/${process.env.VUE_APP_CONTENT_PATH}/sse/sub/${JSON.parse(localStorage.getItem("userInfo")).id}`, {});
      source.onopen = function () {
        console.log("onpen");
      };
      source.onmessage = function () {
        console.log("onmessage");
        that.searchData(false);
      };
      source.onerror = function () {
        console.log("onerror");
      };
    } else {
      console.log("没有SSE");
    }
  },
  mounted() {
    this.editDataSet = {};
    this.initSelect();
    this.searchChnlList();
    window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e)); //监听页面刷新触发事件
  },
  destroyed() {
    //进行监听销毁
    if ("EventSource" in window) {
      var source = new EventSource(
        `${process.env.VUE_APP_BASE_URL}/${process.env.VUE_APP_CONTENT_PATH}/sse/close/${JSON.parse(localStorage.getItem("userInfo")).id}`,
        {}
      );
      source.close();
    } else {
      console.log("没有SSE");
    }
    this.editDataSet = {};
    window.removeEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
  },
  beforeRouteLeave(to, from, next) {
    if (Object.keys(this.editDataSet).length > 0) {
      this.$confirm(`您当前编辑序号为${Object.values(this.editDataSet)[0].ranking}的内容暂未保存，是否继续编辑！`, "提示", {
        confirmButtonText: "继续编辑",
        cancelButtonText: "放弃编辑",
        type: "warning",
        showClose: false,
      })
        .then(() => {
          next(false);
        })
        .catch(() => {
          this.editDataSet = {};
          next();
        });
    } else {
      next();
    }
  },
  computed: {
    weekArr() {
      let selectDay = moment(this.week);
      return [selectDay.subtract(1, "days").format("YYYY-MM-DD"), selectDay.subtract(-6, "days").format("YYYY-MM-DD")];
    },
    readOnly() {
      let day = moment().day();
      let nowWeek = moment()
        .subtract(day - 2, "days")
        .format("YYYY-MM-DD");
      return nowWeek !== this.week;
    },
  },
  watch: {
    weekArr() {
      this.searchData(true);
    },
  },
  methods: {
    beforeunloadHandler(e) {
      //根据事件进行操作进行操作
      e = e || window.event;
      if (e && Object.keys(this.editDataSet).length > 0) {
        e.returnValue = "您是否确认离开此页面-您输入的数据可能不会被保存";
      }
    },
    initSelect() {
      const defaultColums = JSON.parse(JSON.stringify(this.columns));
      getColumn().then((res) => {
        const data = JSON.parse(res.data);
        const obj = data?.filter(
          (item) => !defaultColums.some((ele) => ele.value === item.value && ele.label === item.label && ele.fixed === item.fixed)
        );
        if (res.data && defaultColums.length === data.length && obj.length === 0) {
          this.columns = data;
        }
      });
      //初始化周日期 0周天 6周六
      let day = moment().day();
      this.week = moment()
        .subtract(day - 2, "days")
        .format("YYYY-MM-DD");

      //产品
      getPros({
        order: "asc",
        offset: 0,
        menuName: "materialProductMenu",
      }).then((res) => {
        if (res.code === "0000") {
          this.productList = res.products;
        }
      });
      //投放负责人
      getPrincipalName().then((res) => {
        if (res.code === "0000") {
          this.principalNameList = res.list;
        }
      });
      //产品负责人，项目组，产品分组
      getTotalReportParams().then((res) => {
        if (res.code === "0000") {
          this.groupNameList = res.groupNameList;
          this.principalUserList = res.principalUserList;
          this.productGroupNameList = res.productGroupNameList;
        }
      });
    },
    getStatusByText(text) {
      //产品状态 1稳定投放 2已暂停 3测试中 4上线待测试
      switch (text) {
        case "稳定投放":
          return 1;
        case "已暂停":
          return 2;
        case "测试中":
          return 3;
        case "上线待测试":
          return 4;
        default:
          break;
      }
    },
    searchData(resetPage) {
      this.loading = true;
      if (resetPage) {
        this.pageData.page = 1;
      }
      let parmas = {
        pageSize: this.pageData.size,
        pageIndex: this.pageData.page,
        weeks: this.weekArr.map((item) => item.replace(/-/g, "")).join("-"),
        menuName: "materialProductMenu",
      };
      for (let [label, value] of Object.entries(this.filterData)) {
        if (value && value.length > 0) {
          parmas[label] = value.join();
        }
      }
      getProductLog(parmas).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.tableData = res.list.map((item) => {
            item.chnl && (item.chnl = JSON.parse(item.chnl));
            //产品状态 1稳定投放 2已暂停 3测试中 4上线待测试
            item.status = this.getStatusByText(item.productStatus);
            item.principalName = item.principalName ? item.principalName.split(",") : [];
            if (item.children) {
              item.children.forEach((chil) => {
                chil.chnl && (chil.chnl = JSON.parse(chil.chnl));
                chil.status = this.getStatusByText(chil.productStatus);
                chil.principalName = chil.principalName ? chil.principalName.split(",") : [];
              });
            }
            return item;
          });
          this.pageData.total = res.num;
        }
      });
    },
    addPro() {
      this.$refs.addModalRef.addData();
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData(true);
    },
    showDetailModal(row) {
      this.$refs.detailModalRef.showDetailModal(row);
    },
    rowClassName({ row }) {
      if (row.status === 1) {
        return "greenLine";
      } else {
        return "";
      }
    },
    cellClassName({ column, row }) {
      if (column.property === "appName" && (row.status === 3 || row.status === 4)) {
        return "defaultCell yellowCell";
      } else if (column.property === "appName" && row.status === 2) {
        return "defaultCell blackCell";
      } else {
        return "defaultCell";
      }
    },
    saveData(row) {
      //数据检查
      let curEditData = this.editDataSet[row.id];
      if (parseInt(curEditData.resourceNum) <= 0) {
        this.$message.error("素材迭代组数不规范");
        return;
      }

      let curRow = null;
      for (let i = 0; i < this.tableData.length; i++) {
        let item = this.tableData[i];
        if (item.id === row.id) {
          curRow = item;
          break;
        }
        if (item.children) {
          let chil = item.children.find((c) => c.id === row.id);
          if (chil) {
            curRow = chil;
            break;
          }
        }
      }
      let noChangChnl = JSON.stringify(curRow.chnl) === JSON.stringify(curEditData.chnl);
      let reqData = Object.assign(JSON.parse(JSON.stringify(curRow)), curEditData);
      reqData.chnl = JSON.stringify(reqData.chnl);
      reqData.principalName = reqData.principalName.join();
      reqData.changeChnl = noChangChnl ? 0 : 1;
      delete reqData.children;
      modProductLog(reqData).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          let curPro = this.productList.find((item) => item.id === curEditData.productId);
          Object.assign(curRow, curEditData, {
            status: this.getStatusByText(curEditData.productStatus),
            appName: curPro ? curPro.appName : "-",
          });
          this.$delete(this.editDataSet, row.id);
          // this.searchData();
        }
      });
    },
    cancel(row) {
      this.$delete(this.editDataSet, row.id);
    },
    editLine(row) {
      this.$set(this.editDataSet, row.id, JSON.parse(JSON.stringify(row)));
    },
    deleteData(row) {
      this.$confirm("确定删除产品“" + row.appName + "”?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loadingTable = true;
          this.cancel(row);
          delProductLog({
            id: row.id,
            isChild: row.isChild,
          }).then((res) => {
            this.loadingTable = false;
            if (res.code === "0000") {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              // this.searchData();
            }
          });
        })
        .catch(() => {});
    },
    // 编辑富文本内容
    editRichText(data, value, id) {
      this.$refs.editRich.showDialog(data, value, id);
    },
    handleConfirmEditRich(data, editObj, editId) {
      let curRow = null;
      this.$set(this.editDataSet[editId], editObj.value, JSON.parse(JSON.stringify(data)));
      for (let i = 0; i < this.tableData.length; i++) {
        let item = this.tableData[i];
        if (item.id === editId) {
          curRow = item;
          break;
        }
        if (item.children) {
          let chil = item.children.find((c) => c.id === editId);
          if (chil) {
            curRow = chil;
            break;
          }
        }
      }
      curRow[editObj.value] = data;
    },
    //编辑序号相关
    editRank(row) {
      if (this.readOnly) {
        return;
      }
      this.$set(this.rankSet, row.id, JSON.parse(JSON.stringify(row)));
    },
    saveRank(row) {
      this.$nextTick(() => {
        let curRow = this.tableData.find((item) => item.id === row.id);
        if (!(parseInt(this.rankSet[row.id].ranking) > 0)) {
          this.$message({
            message: "序号不规范",
            type: "warning",
          });
          return;
        }

        let parmas = {
          id: curRow.id,
          weeks: curRow.weeks,
          oldRanking: curRow.ranking,
          newRanking: this.rankSet[row.id].ranking,
        };
        changeRanking(parmas).then((res) => {
          if (res.code === "0000") {
            this.$message({
              message: "序号修改成功",
              type: "success",
            });
            Object.assign(curRow, {
              ranking: this.rankSet[row.id].ranking,
            });
            this.$delete(this.rankSet, row.id);
            // this.searchData();
          }
        });
      });
    },
    cancelRank(row) {
      this.$delete(this.rankSet, row.id);
    },
    customChnl() {
      this.$refs.chnlModalRef.showModal();
    },
    //所有渠道
    searchChnlList() {
      getChnl().then((res) => {
        if (res.code === "0000") {
          this.channelList = res.data.map((item) => {
            return {
              channel: item.channel,
              primary: false,
              secondary: false,
            };
          });
        }
      });
    },
    handleCommand(type) {
      this.reqType = type;
    },
    //文件校验方法
    beforeExcelUpload(file) {
      // 通过split方法和fileArr方法获取到文件的后缀名
      let fileArr = file.name.split(".");
      let suffix = fileArr[fileArr.length - 1];
      //只能导入.xls和.xlsx文件
      if (!/(xlsx)/i.test(suffix)) {
        this.$message("文件格式不正确,只支持xlsx格式");
        return false;
      }
      // //不能导入大小超过2Mb的文件
      // if (file.size > 2 * 1024 * 1024) {
      //   this.$message('文件过大，请上传小于2MB的文件〜')
      //   return false
      // }
      return true;
    },
    uploadExcel(file) {
      //判断是否符合beforeExcelUpload方法中的条件
      if (this.beforeExcelUpload(file)) {
        this.fileList.name = file.name;
        this.fileList.url = "";
        const formdata = new FormData();
        formdata.append("file", file.raw);
        formdata.append("reqType", this.reqType);
        axios({
          method: "POST",
          url: `/${process.env.VUE_APP_CONTENT_PATH}/productLog/uploadProductLogData`,
          data: formdata,
          baseURL: process.env.VUE_APP_BASE_URL,
          headers: {
            "Content-Type": "multipart/form-data; ",
          },
        }).then((res) => {
          if (res.data.code === "0000") {
            const errorList = Object.values(res.data.data);
            if (errorList[0].concat(errorList[1], errorList[2], errorList[3], errorList[4], errorList[5], errorList[6]).length > 0) {
              const msgList = [
                "afid为空",
                "afid对应的产品不存在",
                "时间为空",
                "时间格式错误",
                "投放负责人未使用/分隔",
                "主要渠道字段未用/分隔",
                "AFID-时间重复",
              ];
              this.errorList = [];
              errorList.map((item, index) => {
                if (item.length > 0) {
                  this.errorList.push({
                    list: item,
                    key: index,
                    errorMsg: msgList[index],
                  });
                }
              });
              this.errorDialogVisible = true;
            } else {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            }
            this.initSelect();
            this.searchChnlList();
          }
        });
      }
    },
    // 拖动表头进行存储
    headerDragend(newWidth, oldWidth, column) {
      const findObj = this.columns.find((item) => item.value === column.property);
      findObj.width = newWidth;
      addColumn({
        val: JSON.stringify(this.columns),
      });
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    downloadReport() {
      this.downloadLoading = true;
      let parmas = {
        weeks: this.weekArr.map((item) => item.replace(/-/g, "")).join("-"),
        menuName: "materialProductMenu",
      };
      for (let [label, value] of Object.entries(this.filterData)) {
        if (value && value.length > 0) {
          parmas[label] = value.join();
        }
      }
      getProductLog(parmas).then((res) => {
        this.downloadLoading = false;
        if (res.code === "0000") {
          let newList = [];
          const list = res.list.map((item) => {
            item.chnl && (item.chnl = JSON.parse(item.chnl));
            //产品状态 1稳定投放 2已暂停 3测试中 4上线待测试
            item.status = this.getStatusByText(item.productStatus);
            if (item.children) {
              item.children.forEach((chil) => {
                chil.chnl && (chil.chnl = JSON.parse(chil.chnl));
                chil.status = this.getStatusByText(chil.productStatus);
              });
            }
            return item;
          });
          list.map((item) => {
            newList = newList.concat(item);
            if (item.children && item.children.length > 0) {
              newList = newList.concat(item.children);
            }
          });
          const dataList = this.formatTableData(newList);
          //表头映射
          const HeaderData = {};
          this.columns
            .filter((child) => !["doSth", "fold"].includes(child.value))
            .forEach((item) => {
              HeaderData[item.value] = item.label;
            });
          console.log(HeaderData, dataList);
          downLoadWrokSheet(dataList, "投放信息记录.xlsx", HeaderData);
        }
      });
    },
    formatTableData(list) {
      return list.map((item) => {
        item.chnl = item.chnl ? item.chnl.map((item) => item.channel).join("、") : "-";
        ["type", "resourceNum", "ranking", "market", "productGrade", "appName"].map((key) => {
          item[key] = item[key] ? item[key] : "-";
        });
        //通用字段
        return item;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.page-wrap {
  padding: 16px 16px 0px 16px;
  box-sizing: border-box;
  height: 100vh - 0px;
  .header-filter {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding-top: 16px;
    .header-text {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 15px;
      margin-right: 24px;
      margin: 0px 24px 0px 24px;
    }
    .select-wrap {
      display: flex;
      align-items: center;
      padding: 16px 24px 16px 24px;
      .select-item {
        width: 200px;
        margin: 0px 24px 16px 0px;
      }
      .multiple-select {
        width: 150px;
        margin-right: 24px;
        /deep/ .el-tag.el-tag--info:first-child {
          max-width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .table-wrap {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 24px;
    height: calc(100vh - 275px);
    position: relative;
    .loading-icon {
      position: absolute;
      top: 6px;
      left: 24px;
    }
    .red-text {
      color: red;
    }
    .rank-wrap {
      display: flex;
      align-items: center;
      /deep/ .el-input__inner {
        padding-right: 0px;
      }
    }
    .edit-ranking {
      color: rgba(24, 144, 255, 1);
      font-size: 14px;
      cursor: pointer;
    }
    .edit-btns {
      display: inline-block;
      margin-right: 16px;
    }
    .input-area {
      /deep/ .el-textarea__inner {
        // height: 100px;
      }
    }

    /deep/ .greenLine {
      .defaultCell {
        background: rgba(32, 175, 55, 0.21);
      }
    }
    /deep/ .defaultCell {
      background: #fff;
      vertical-align: top;
    }
    /deep/ .yellowCell {
      background: rgba(255, 235, 59, 0.49);
    }
    /deep/ .blackCell {
      background: #ccc;
    }
    .show-text {
      font-size: 14px;
      color: #606266;
      .channel-item {
        &.main {
          color: rgb(50, 182, 110);
        }
      }
    }
    /deep/ .el-table__fixed-right {
      background-color: #fff;
    }
    /deep/ .el-table__fixed {
      background-color: #fff;
    }
    .chnl-wrap {
      display: flex;
      .area-wrap {
        width: 100%;
      }
    }
    .menu-icon {
      flex-shrink: 0;
      margin-left: 4px;
      cursor: pointer;
    }
    .html-textarea {
      /deep/ p {
        margin-block-start: 0em;
        margin-block-end: 0em;
      }
    }
  }
  .footer-page {
    padding: 6px 0;
  }
  .error-title {
    color: black;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 12px;
  }
  .error {
    .error-content {
      font-weight: 600;
      font-size: 15px;
      margin-top: 8px;
    }
    .error-value {
      .number {
        color: red;
        font-weight: 600;
      }
    }
  }
}
</style>
